import {
  dictionariesTranslation,
  DictionariesTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import {
  errorMessagesTranslation,
  ErrorMessagesTranslation,
} from '@/assets/locales/utils/errorMessages/errorMessages.translation.pl.ts';
import { sseTranslation, SseTranslation } from '@/assets/locales/utils/sse/sse.translation.pl.ts';
import {
  toastsTranslation,
  ToastsTranslation,
} from '@/assets/locales/utils/toasts/toasts.translations.pl.ts';
import {
  userContextTranslation,
  UserContextTranslation,
} from '@/assets/locales/utils/userContext/userContext.translation.pl.ts';

export type UtilsTranslation = {
  dictionaries: DictionariesTranslation;
  errorMessages: ErrorMessagesTranslation;
  sse: SseTranslation;
  toasts: ToastsTranslation;
  userContext: UserContextTranslation;
};

export const utilsTranslation: UtilsTranslation = {
  dictionaries: dictionariesTranslation,
  errorMessages: errorMessagesTranslation,
  sse: sseTranslation,
  toasts: toastsTranslation,
  userContext: userContextTranslation,
};
